import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "./anim";

const IMG =
  "https://images.unsplash.com/photo-1520699894975-334692f3a636?auto=format&fit=crop&w=2400&q=80";

export default function FinalCta({ onBook }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="final-cta-section" className="relative overflow-hidden border-t border-white/10">
      <motion.div style={{ y }} className="absolute inset-0">
        <img
          src={IMG}
          alt="Geometric lines of modern architecture converging, a path forward"
          className="h-[125%] w-full scale-105 object-cover brightness-[0.55]"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[#08080A]/70" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#08080A] via-transparent to-[#08080A]" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-4xl px-5 py-32 text-center sm:px-8 sm:py-44">
        <Reveal>
          <img
            src="/assets/logo.jpeg"
            alt="Kingdom Wealth Enterprises lion and crown emblem"
            data-testid="final-cta-logo"
            className="mx-auto mb-10 h-20 w-20 rounded-full border border-[#C5A059]/40 object-cover object-top shadow-[0_0_60px_rgba(197,160,89,0.25)]"
          />
        </Reveal>
        <Reveal>
          <Overline className="justify-center">Begin Here</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 text-3xl font-light leading-[1.12] tracking-tight text-[#F9F8F6] sm:text-4xl lg:text-5xl">
            Your next opportunity deserves a <span className="text-[#C5A059]">strategy.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-6 max-w-xl text-base font-light leading-relaxed text-[#C9C9CF]">
            Opportunities move quickly, and delay has a cost. Schedule a consultation to discuss your goals and
            identify your next wealth-building opportunity.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <button data-testid="final-book-cta" onClick={onBook} className="btn-gold mt-10 px-10 py-4 text-base">
            Schedule a Consultation
          </button>
        </Reveal>
      </div>
    </section>
  );
}
